function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "fam-tree",
  transform: "translate(0.000000, -1.000000)",
  fill: "#3B3A42",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M25,14 L25,18.1260031 C26.7252804,18.570015 28,20.1360669 28,22 C28,24.2092362 26.2092362,26 24,26 C21.7907638,26 20,24.2092362 20,22 C20,20.1360669 21.2747196,18.570015 23,18.1260031 L23,14 L15,14 L15,18.1260031 C16.7252804,18.570015 18,20.1360669 18,22 C18,24.2092362 16.2092362,26 14,26 C11.7907638,26 10,24.2092362 10,22 C10,20.1360669 11.2747196,18.570015 13,18.1260031 L13,14 L5,14 L5,18.1260031 C6.7252804,18.570015 8,20.1360669 8,22 C8,24.2092362 6.20923617,26 4,26 C1.79076383,26 0,24.2092362 0,22 C0,20.1360669 1.2747196,18.570015 3,18.1260031 L3,14 L3,12 L13,12 L13,8.87399687 C11.2747196,8.42998498 10,6.86393309 10,5 C10,2.79076383 11.7907638,1 14,1 C16.2092362,1 18,2.79076383 18,5 C18,6.86393309 16.7252804,8.42998498 15,8.87399687 L15,12 L25,12 L25,14 Z M16,5 C16,3.89533333 15.1046667,3 14,3 C12.8953333,3 12,3.89533333 12,5 C12,6.10466667 12.8953333,7 14,7 C15.1046667,7 16,6.10466667 16,5 Z M16,22 C16,20.8953333 15.1046667,20 14,20 C12.8953333,20 12,20.8953333 12,22 C12,23.1046667 12.8953333,24 14,24 C15.1046667,24 16,23.1046667 16,22 Z M26,22 C26,20.8953333 25.1046667,20 24,20 C22.8953333,20 22,20.8953333 22,22 C22,23.1046667 22.8953333,24 24,24 C25.1046667,24 26,23.1046667 26,22 Z M6,22 C6,20.8953333 5.10466667,20 4,20 C2.89533333,20 2,20.8953333 2,22 C2,23.1046667 2.89533333,24 4,24 C5.10466667,24 6,23.1046667 6,22 Z",
  id: "Combined-Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "28px",
    height: "25px",
    viewBox: "0 0 28 25",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/fam-tree.2755f794.svg";
export { SvgComponent as ReactComponent };